import { Box, Typography } from "@mui/material";
import React from "react";

function DataChip({ color, content, sx, ...rest }) {
  return (
    <Box
      sx={{
        width: "170px",
        height: "34px",
        backgroundColor: "gray-background.main",
        display: "flex",
        alignItems: "center",
        px: 1,
        ...sx,
      }}
      {...rest}
    >
      <Box
        sx={{
          width: "2px",
          height: "80%",
          backgroundColor: color,
          mr: 1,
        }}
      ></Box>
      <Typography variant="body1" color={color}>
        {content}
      </Typography>
    </Box>
  );
}

export default DataChip;
